export const ShareWithCopyLinkAndEmailComponent = {
	templateUrl: 'share-with-copy-link-and-email.html',
	bindings: {
		comissionId: '<'
	},
	controller: class shareWithCopyLinkAndEmailContoller {
		constructor($scope, messagingService) {
			'ngInject';
			this.$scope = $scope;
			this.messagingService = messagingService;
			this.location = window.location.href;
		}

		$onInit() {
			this.showCopyLink = !!document.execCommand && !!window.getSelection;
		}

		sendShareEmail(event) {
			this.shareResponse = '';
			let shareMessage = event.share;
			let captcha = shareMessage.captcha;
			delete shareMessage.captcha;
			shareMessage.url = this.location;
			this.messagingService.sendMessageToPerson(shareMessage, captcha).then(
				(response) => {
					if (response.status == 200) {
						this.shareResponse = true;
					}
				},
				(error) => {
					this.shareResponse = error;
				}
			);
		}

		copyToClipboard(domId) {
			window.dataLayer.push({
				event: 'copyPropertyLink'
			});
			var $element = angular.element('#' + domId);
			var range = document.createRange();
			range.selectNode($element[0]);
			window.getSelection().addRange(range);  
			document.execCommand('copy');
			// clear selection
			if (window.getSelection) {
				if (window.getSelection().empty) {  // Chrome
					window.getSelection().empty();
				} else if (window.getSelection().removeAllRanges) {  // Firefox
					window.getSelection().removeAllRanges();
				}
			} else if (document.selection) {  // IE?
				document.selection.empty();
			}
		}
	}
};
